<template>
    <div class="map-box">
        <div class="click-box" @click="open" :style="{width: width + 'px', height: height + 'px'}">
            <baidu-map
                  class="min-map pointer"
                  ak='I1l6aGmZIgkUWerovjVSfTNkIbHGWNm9'
                  :center="editCenter"
                  :zoom="20"
                  :dragging="false"
                  :map-click="false"
                  :double-click-zoom="false"
                  v-show="editCenter.lng"
                  @ready="map_handler_1"
                >
                <el-popover popper-class="M_header__popover"
                    placement="start"
                    trigger="hover"
                    v-if="canClick">
                    <p>点击修改地址</p>
                    <div class="station-container" slot="reference">
                        <div class="map-center" v-show="editCenter.lng">
                            <span></span>
                        </div>
                    </div>
                </el-popover>
                <div class="station-container" v-else>
                    <div class="map-center" v-show="editCenter.lng">
                        <span></span>
                    </div>
                </div>
                <div class="mark" v-show="editCenter.lng"></div>
            </baidu-map>
        </div>
        <!-- 查看或编辑地图地点 -->
        <dialog-template
            :visible.sync="map_show"
            :width="canClick ? '680px' : '580px'"
            class="map-dialog"
            :headerTitle="canClick ? '位置' : '地图地址'"
            @closed="mapClose"
            :append-to-body="true"
            custom-class="__dialog__map__wrapper__"
            >
            <template>
                <div>
                    <div v-if="canClick" :class="['search-inp', {'active': is_focus}]">
                        <el-input v-model="searchPlace" @keydown.native.enter="searchChange" @input="isShowCloseIcon = searchPlace !== ''" placeholder="输入要搜索的地点" @focus="focus" @blur="blur">
                        <i slot="append" class="icongonggongguanbi2 iconfont" @click="() => { searchPlace = ''; isShowCloseIcon = false; isShowSearchTips = false }" v-if="isShowCloseIcon"/>
                        <el-button slot="append"  @click="searchChange"><span class="line"></span>搜索</el-button>
                        </el-input>
                    </div>
                    <div class="main-container">
                        <baidu-map
                            id="main-map"
                            class="main-map"
                            ak='I1l6aGmZIgkUWerovjVSfTNkIbHGWNm9'
                            :center="mapCenter"
                            :zoom="mapZoom"
                            :scroll-wheel-zoom="false"
                            :pageCapacity="100"
                            @dragend="(e) => { isHasDragEnd = true; getMapCenter(e) }"
                            @ready="map_handler"
                            :mapClick="false"
                        >
                            <template v-if="canClick">
                                <div class="result-pane">
                                    <div class="current-place tl">
                                        <div style="width:calc(100% - 22px)" class="c333 f14 text-popper" v-textPopper>{{currentPlace}}</div>
                                        <div style="width:calc(100% - 22px)" class="f12 c999 text-popper" v-textPopper>{{currentPlaceDetail}}</div>
                                        <div class="is-selected" v-show="currentPlace && isSelectedShow"></div>
                                    </div>
                                    <p style="line-height: 20px; padding: 10px 10px 0; color: #333; font-size: 14px; font-weight: 600;" v-if="isShowSearchTips">搜索结果: </p>
                                    <div class="search-pane-wrap">
                                        <bm-local-search
                                            @markersset="markersset"
                                            @infohtmlset="infohtmlset"
                                            @resultshtmlset="resultshtmlset"
                                            :pageCapacity="100"
                                            class="search-pane"
                                            :keyword="searchLabel"
                                            :forceLocal="true"
                                            shape="BMAP_POINT_SHAPE_STAR"
                                            :selectFirstResult="true"
                                            :auto-viewport="false"
                                            :location="searchLocation">
                                        </bm-local-search>
                                    </div>
                                </div>
                                <div class="map-center" :class="{'active': isMapCenterActive}">
                                    <span></span>
                                </div>
                                <div class="mark"></div>
                            </template>
                            <template v-else>
                                <div class="cur-address map-btn fx-v-center" @click="() => { isHasDragEnd && (isHasClickCenter = true); updateCenter(propAddress) }">
                                    <span>{{ detail }}</span>
                                    <img src="./images/dingwei.svg" alt="">
                                </div>
                                <bm-marker :position="editCenter" :dragging="false" :icon="{url: zhizhen, size: {width: 24, height: 47}}" :offset="(isHasDragEnd && isHasClickCenter) ? {} : { width: 300, height: -50 }" >
                                    <bm-label content="" :labelStyle="{ backgroundColor: 'rgba(0, 0, 0, .7)', width: '15px', height: '15px', borderRadius: '15px', border: 'none', transform: 'scaleX(0.5) scaleY(0.3) translateX(1px)',  }" :offset="{width: 4, height: 41}"/>
                                </bm-marker>
                            </template>
                            <bm-control class="control-wrap">
                                <div class="mb10" style="padding-top:1px">
                                    <button class="map-btn" @click="() => { isHasDragEnd = isHasClickCenter = true; getLocal() }">
                                        <i class="el-icon-aim"></i>
                                    </button>
                                </div>
                                <div class="mb10"><button class="add-btn map-btn" @click="mapZoom++"><span>+</span></button></div>
                                <div><button class="minus-btn map-btn" @click="mapZoom--"><span>-</span></button></div>
                            </bm-control>
                            <bm-view class="bm-view-wrap">
                            </bm-view>
                        </baidu-map>
                    </div>
                </div>
            </template>
            <template v-if="canClick" slot="footer">
                <el-button type="primary" @click="surePosition">保存</el-button>
                <el-button @click="map_show = false">取消</el-button>
            </template>
        </dialog-template>
    </div>
</template>

<script>
import { BaiduMap, BmScale, BmLabel, BmGeolocation, BmLocalSearch, BmControl, BmView, BmMarker } from 'vue-baidu-map'
import addressSelectObj from '@/assets/ts/area.ts'

export default {
    props: {
        searchLocation: {
            type: String,
            default: ''
        },
        selfMarkerImg: {
            type: String,
            default: require('./images/self1.svg')
        },
        searchMarkerImg: {
            type: String,
            default: require('./images/search-marker.svg')
        },
        width: {
            type: String,
            default: '120'
        },
        height: {
            type: String,
            default: '40'
        },
        propAddress: {
            type: Object,
            default: () => {}
        },
        canClick: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            dialogVisible: false,
            zhizhen: require('./images/zhizhen.svg'),
            location: '北京',
            keyword: '百度',
            mapCenter: {
                lng: 0,
                lat: 0
            },
            mapPointer: {},
            currentPointer: {},
            currentPlace: '',
            // searchLocation: '武汉市',
            currentPlaceDetail: '',
            is_focus: false,
            mapZoom: 15,
            searchPlace: '',
            searchLabel: '',
            detail: '',
            map_show: false,
            is_edit: false,
            isHasDragEnd: false,
            isHasClickCenter: false,
            shop_center: {},
            editCenter: {},
            BMap: null,
            isMapCenterActive: false,
            isSelectedShow: true,
            isShowCloseIcon: false,
            isShowSearchTips: false
        }
    },

    watch: {
        propAddress: {
            handler(val) {
                this.isShowCloseIcon = false
                this.isShowSearchTips = false
                this.updateCenter(val)
            },
            deep: true
        }
    },

    methods: {
        open() {
            this.map_show = true
            this.updateCenter(this.propAddress)
        },

        map_handler({ BMap, map }) {
            this.newMap = map
            this.BMap = BMap
            const geolocation = new BMap.Geolocation()
            this.map_handle_common(() => {
                geolocation.getCurrentPosition((r) => {
                    this.mapMarker(BMap, this.selfMarkerImg, r.point, { width: 20, height: 40 }, 'self')
                    this.currentPointer = r.point
                    if (!this.mapCenter.lng) {
                        this.getCurlocation()
                    }
                })
                if (this.canClick) {
                    // 一定要转成百度地图的坐标点才能使用
                    const point = new BMap.Point(this.mapCenter.lng, this.mapCenter.lat)
                    this.getMapAddress(point, true)
                }
            })
        },

        mapMarker(BMap, iconUrl, point, size, title = 'icon') {
            const myIcon = new BMap.Icon(iconUrl, new BMap.Size(size.width, size.height))
            const marker = new BMap.Marker(point, { icon: myIcon })
            marker.setTitle(title)
            marker.disableMassClear()
            this.newMap.addOverlay(marker)
        },

        map_handler_1({ BMap, map }) {
            this.newMap1 = map
            this.BMap1 = BMap
            this.map_handle_common()
        },

        map_handle_common(cb = function() {}) {
            if (this._propAddress) {
                const arr = [
                    this._propAddress.pCode,
                    this._propAddress.cCode,
                    this._propAddress.dCode
                ]
                const geo = new BMap.Geocoder()
                this.addressToPoint(geo, addressSelectObj.initProviceAndCity(...arr).concat(this._propAddress.address).join(''), addressSelectObj.getCityName(this._propAddress.pCode, this._propAddress.cCode)).then(point => {
                    this.editCenter = this.mapCenter = point
                }).catch(e => {
                    console.log(e)
                }).finally(cb)
            } else {
                cb()
            }
        },

        getCurlocation() {
            // 获取浏览器当前定位
            if (!this.BMap) { return false }
            this.mapCenter = this.currentPointer
            this.getMapAddress(this.currentPointer)
        },

        dragend({ point }) {
            const BMap = this.BMap
            const geo = new BMap.Geocoder()
            const oThis = this
            this.pointToAddress(geo, point).then(res => {
                oThis.currentPlace = res.address
                oThis.currentPlaceDetail = res.address
            }).catch(e => {
                console.log(e)
            })
        },

        surePosition() {
            const BMap = this.BMap
            const geo = new BMap.Geocoder()
            this.shopAddressDetail = this.currentPlace
            this.addressToPoint(geo, this.currentPlaceDetail, this.searchLocation).then(point => {
                // this.editCenter = point
                new this.BMap.Geocoder().getLocation(point, (rs) => {
                    const {
                        province,
                        city,
                        district,
                        street,
                        streetNumber
                    } = rs.addressComponents
                    const {
                        province_code,
                        city_code,
                        district_code
                    } = addressSelectObj.initProviceAndCityCode(province, city, district)
                    this.updateCenter({
                        address: street + streetNumber,
                        pCode: province_code,
                        cCode: city_code,
                        dCode: district_code
                    })
                    this.$emit('getAddress', {
                        point,
                        p_c_d_code: [province_code, city_code, district_code].filter(el => el != null),
                        address: this.getCleanAddress(this.currentPlaceDetail)
                    })
                })
            }).catch(e => {
                console.log(e)
            })
            this.map_show = false
        },

        getMapCenter(e) {
            this.isMapCenterActive = true
            this.isShowSearchTips = false
            // 获取地图中心点
            if (!this.BMap) { return false }
            const point = this.mapCenter = e.target.getCenter()
            if (this.canClick) {
                this.getMapAddress(point, true)
                setTimeout(() => {
                    this.isMapCenterActive = false
                }, 600)
            }
        },

        getMapAddress(point, ifUpdateAddress) {
            if (!this.BMap) { return false }
            const oThis = this
            const BMap = this.BMap
            const geoc = new BMap.Geocoder()
            geoc.getLocation(point, function(rs) {
                const addComp = rs.addressComponents
                const surround = rs.surroundingPois
                oThis.province_name = addComp.province
                oThis.city_name = addComp.city
                oThis.district_code = addComp.district
                const isSuccess = addressSelectObj.initProviceAndCityCode(
                    addComp.province,
                    addComp.city,
                    addComp.district
                )
                if (!isSuccess) {
                    // openMessage('error', '地址库中未找到当前地址，请切换地址信息重试')
                    return false
                }
                if (ifUpdateAddress) {
                    // oThis.searchPlace = addComp.street + addComp.streetNumber
                    if (surround && surround.length !== 0) {
                        oThis.currentPlace = surround[0].title
                        oThis.currentPlaceDetail = rs.address
                        oThis.searchLabel = surround[0].title
                    } else {
                        oThis.currentPlace = ''
                        oThis.currentPlaceDetail = ''
                        oThis.searchLabel = ''
                    }
                }
            })
        },

        // 地址解析
        addressToPoint(obj, address, city) {
            return new Promise((resolve, reject) => {
                obj.getPoint(address, point => {
                    let data = null
                    if (point) {
                        data = point
                    }
                    resolve(data)
                }, city)
            })
        },

        mapClose() {
            this.searchPlace = ''
        },

        focus() {
            this.is_focus = true
        },

        blur() {
            this.is_focus = false
        },

        searchChange() {
            this.isShowSearchTips = true
            this.searchLabel = this.searchPlace
        },

        markersset(pois) {
            const oThis = this
            const BMap = this.BMap
            this._lastPois = pois
            pois.forEach(item => {
                const poi = item.marker
                poi.addEventListener('infowindowopen', () => {
                    poi.closeInfoWindow()
                    oThis.newMap.closeInfoWindow()
                    return false
                })
                poi.addEventListener('click', () => {
                    this.isSelectedShow = true
                    const searchList = document.getElementsByClassName('search-list-active')
                    for (const searchResult of searchList) {
                        searchResult.className = 'search-list'
                    }
                    this.mapCenter = item.point
                    return false
                })
                const icon = new BMap.Icon(this.searchMarkerImg, new BMap.Size(20, 40))
                poi.setIcon(icon)
            })
        },

        infohtmlset(LocalResultPoi) {
            this.currentPlace = LocalResultPoi.title
            this.currentPlaceDetail = LocalResultPoi.address
        },

        resultshtmlset(container) {
            const resHtml = container.getElementsByTagName('li')
            for (let i = 0; i < resHtml.length; i++) {
                resHtml[i].className += 'search-list'
                resHtml[i].addEventListener('click', (e) => {
                    for (let j = 0; j < resHtml.length; j++) {
                        if (i !== j) {
                            resHtml[j].className = 'search-list'
                        }
                    }
                    this.isSelectedShow = false
                    resHtml[i].className += ' search-list-active'
                })
            }
        },

        getLocal() {
            this.mapCenter = this.currentPointer
            this.newMap.panTo(this.currentPointer)
        },


        replaceIcon(iconPath, marker, sizeW, sizeH) {
            const BMap = this.Bmap
            this.newMap.removeOverlay(marker)
            const myIcon = new BMap.Icon(require('./images/self1.svg'), new BMap.Size(sizeW, sizeH))
            const newMarker = new BMap.Marker(marker.point, { icon: myIcon })
            this.newMap.addOverlay(newMarker)
        },

        mapInit() {
            this.currentPlace = ''
            this.currentPlaceDetail = ''
            this.searchLabel = this.searchPlace = ''
        },

        getCleanAddress(val) {
            let newVal = val
            if (val.includes('区')) {
                newVal = newVal.slice(newVal.indexOf('区') + 1)
            } else if (val.includes('市')) {
                newVal = newVal.slice(newVal.indexOf('市') + 1)
            } else if (val.includes('省')) {
                newVal = newVal.slice(newVal.indexOf('省') + 1)
            }
            return newVal
        },

        updateCenter(val) {
            if (!this.BMap1) {
                this._propAddress = val
                return
            }
            const arr = [
                val.pCode,
                val.cCode,
                val.dCode
            ]
            const BMap = this.BMap1
            const geo = new BMap.Geocoder()
            const detail = addressSelectObj.initProviceAndCity(...arr).concat(val.address).join('')
            const target = addressSelectObj.getCityName(val.pCode, val.cCode)
            this.detail = detail
            this.addressToPoint(geo, detail, target).then(point => {
                this.editCenter = this.mapCenter = point
                geo.getLocation(point, (rs) => {
                    const addComp = rs.addressComponents
                    this.province_name = addComp.province
                    this.city_name = addComp.city
                    this.district_code = addComp.district
                })
            }).catch(e => {
                console.log(e)
            })
        }
    },

    components: {
        BaiduMap,
        BmLabel,
        BmScale,
        BmGeolocation,
        BmLocalSearch,
        BmControl,
        BmView,
        BmMarker
    }
}
</script>

<style lang="scss">
.M_header__popover {
    left: 8px;
    top: -40px;
    min-width: 100px !important;

    &::after {
        content: '';
        position: absolute;
        left: 50%;
        bottom: -11px;
        margin-left: -6px;
        border: 6px solid transparent;
        border-top-color: #fff;
    }
}

.__dialog__map__wrapper__ {
    .map-center {
        position: absolute;
        top: 36%;
        left: 73.5%;
        line-height: 1;
        z-index: 99;
        > span {
            display: inline-block;
            width: 20px;
            height: 38px;
            background: url('./images/zhizhen.png') no-repeat center center/18px;
            position: relative;
            margin-left: 50%;
            transform: translateX(-50%);
        }
    }

    .mark {
        display: block;
        z-index: 9;
        width: 15px;
        height: 15px;
        background: rgba(0, 0, 0, 0.7);
        border-radius: 15px;
        position: absolute;
        top: 45%;
        left: 73.84%;
        transform: scaleX(0.5) scaleY(0.3);
    }

    .map-center.active {
        animation: identifier 0.3s 2 linear;
    }
    .el-dialog__body {
        > div {
            padding: 1px;
            .search-inp {
            position: relative;
            border-radius: 4px;
            border: 1px solid #dcdfe6;
            margin-bottom: 10px;
            .icongonggongguanbi2 {
                position: absolute;
                top: 50%;
                right: 111px;
                transform: translateY(-50%);
                width: 16px;
                height: 16px;
            }
            .el-input__inner {
                border: none !important;
            }
            .el-input-group__append {
                padding: 0 !important;
                width: 80px;
                border: none !important;
                background-color: #fff;
                .el-button {
                width: 100%;
                font-size: 14px;
                position: relative;
                .line {
                    position: absolute;
                    height: 20px;
                    width: 1px;
                    background-color: #dcdfe6;
                    left: 0;
                    top:50%;
                    transform: translateY(-50%);
                }
                > span {
                    margin-left: 17px;
                }
                }
            }
            &.active {
                border-color: #47B8A0;
                .el-button {
                color :#47B8A0;
                .line {
                    background-color: #47B8A0;
                }
                }
            }
            }
            .main-container {
                height: 340px;
                position: relative;

                .main-map {
                    width: 100%;
                    height: 100%;
                    display: flex;
                    overflow: hidden;
                    .result-pane {
                    z-index: 999;
                    background-color: #f7f7f7 !important;
                    box-shadow: 2px 0 5px 0 rgba(0,0,0,0.20);
                    width: 50%;
                    height: 100%;
                    .current-place {
                        padding: 10px 0;
                        width: calc(100% - 20px);
                        margin: 0 auto;
                        height: 60px;
                        line-height: 20px;
                        border-bottom: 1px solid rgba(0,0,0,.1);
                        position: relative;
                        text-align: left;

                        .is-selected {
                            position: absolute;
                            right: 0;
                            top: 50%;
                            transform: translateY(-50%);
                            width: 18px;
                            height: 18px;
                            border: 1px solid #08A681;
                            border-radius: 50%;
                        }

                        .is-selected:after {
                            position: absolute;
                            top: 2px;
                            left: 2px;
                            width: 12px;
                            height: 12px;
                            background: #08A681;
                            content: "";
                            display: block;
                            border-radius: 50%;
                        }
                    }
                    .search-pane-wrap {
                        padding: 10px 0;
                        width:100%;
                        height: calc(100% - 60px);
                        overflow-y: auto;
                        &::-webkit-scrollbar {
                        width: 4px;
                        }
                        .search-pane {
                        > div {
                            width: 100%;
                            border: none !important;
                            background-color: #f7f7f7 !important;
                            > div {
                            width: 100%;
                            background-color: #f7f7f7 !important;
                            ol {
                                width: 100%;
                                li {
                                width: 100%;
                                margin:0 !important;
                                padding: 0 !important;
                                position: relative;
                                > span {
                                    display: none !important;
                                }
                                > div {
                                    width: 100%;
                                    padding: 5px 32px 5px 10px !important;
                                    > div:first-child {
                                    text-align: left !important;
                                    span {
                                        color: #333 !important;
                                        font-size: 14px;
                                    }
                                    a {
                                        display: none;
                                    }
                                    }
                                    > div:nth-child(2) {
                                    span {
                                        white-space: nowrap;
                                        text-overflow: ellipsis;
                                        text-align: left;
                                    }
                                    }
                                    > div:nth-child(3) {
                                    display: none;
                                    }
                                }
                                }
                            }
                            }
                            > div:last-child {
                            visibility: hidden;
                            height: 0px;
                            padding: 0;
                            margin: 0;
                            }
                        }
                        }
                    }
                    }
                    .map-btn {
                        background-color: #fff;
                        cursor: pointer;

                        &:active {
                            background-color: rgba(255, 255, 255, .8)
                        }
                    }
                    .cur-address {
                        position: absolute;
                        top: 10px;
                        left: 50%;
                        transform: translateX(-50%);
                        width: 360px;
                        padding: 8px 10px;
                        color: #333;
                        background-color: #fff;
                        box-shadow: 0 2px 5px 0 rgba(0, 0, 0, .2);
                        border-radius: 20px;
                        box-sizing: border-box;
                        z-index: 1;

                        span {
                            flex: 1;
                            display: inline-block;
                            line-height: 20px;
                        }

                        img {
                            flex: none;
                            margin-left: 12px;
                            height: 20px;
                        }
                    }
                    .control-wrap {
                    position: absolute;
                    right: 10px !important;
                    bottom: 10px !important;
                    top:unset !important;
                    left: unset !important;
                    div {
                        text-align: right;
                        margin-top: 10px;
                        button {
                        box-shadow: 0 2px 10px 0 rgba(0,0,0,0.20);
                        width: 32px;
                        height: 32px;
                        line-height: 32px;
                        border-radius: 50%;
                        padding: 0;
                        margin: 0;
                        border: none;
                        font-size: 20px;
                        outline: none;
                        color: #000;
                        }

                        .add-btn,
                        .minus-btn {
                            position: relative;
                            font-size: 38px;
                            font-weight: lighter;

                            span {
                                position: absolute;
                                left: 50%;
                                top: 50%;
                                transform: translate(-50%, -50%);
                                height: 38px;
                            }
                        }
                    }
                    }
                    .bm-view-wrap {
                    position: relative;
                    flex:1;
                    height: 100%;
                    }
                }
            }
        }
    }

    .el-dialog__footer {
        text-align: center;
        padding-top: 20px !important;
    }

    .BMap_Marker.BMap_noprint[headerTitle=myself]:after {
        position: absolute;
        top: 0;
        left: 0;
        display: block;
        width: 200px;
        height: 200px;
        background: rgba(0,174,255,0.2);
        content: "";
        border-radius: 50%;
        transform: translateX(-45%) translateY(-45%);
    }
    .search-list-active::after {
        position: absolute;
        top: 50%;
        right: 9px;
        transform: translateY(-50%);
        display: block;
        width: 12px;
        height: 12px;
        content: "";
        background: #08A681;
        border-radius: 50%;
    }
    .search-list-active::before {
        position: absolute;
        top: 50%;
        right: 6px;
        transform: translateY(-50%);
        display: block;
        width: 16px;
        height: 16px;
        content: "";
        border: 1px solid #08A681;
        border-radius: 50%;
    }
}
@keyframes identifier {
    50% {
        transform: translateY(-10px)
    }
}
</style>

<style scoped lang="scss">
.map-box {
    display: inline-block;
    border-radius: 4px;

    .map-center {
        position: absolute;
        top: 36%;
        left: 73.5%;
        line-height: 1;
        z-index: 99;
        > span {
            display: inline-block;
            width: 20px;
            height: 38px;
            background: url('./images/zhizhen.png') no-repeat center center/18px;
            position: relative;
            margin-left: 50%;
            transform: translateX(-50%);
        }
    }

    .mark {
        display: block;
        z-index: 9;
        width: 15px;
        height: 15px;
        background: rgba(0, 0, 0, 0.7);
        border-radius: 15px;
        position: absolute;
        top: 45%;
        left: 73.84%;
        transform: scaleX(0.5) scaleY(0.3);
    }

    .map-center.active {
        animation: identifier 0.3s 2 linear;
    }
    .click-box {
        position: relative;
        border-radius: 4px;
        background: url('./images/map-back.png');
        background-size: contain;
        cursor: pointer;

        ::v-deep.min-map {
            width: 100%;
            height: 100%;
            display: flex;

            > div:first-child {
                border-radius: 4px !important;
            }

            .map-center {
                top: 0;
                right: 0;
                bottom: 0;
                left: 0;
                margin: auto;
                > span {
                    width: 10px;
                    background-size: contain;
                }
            }

            .mark {
                top: 53%;
                left: 44%;
            }
        }
    }
}
</style>
